<template>
    <div class="page-rules">
        <div class="rules-container">
            <div class="bg-img"></div>
            <div ref="overlay" class="page-overlay"></div>
            <div class="rules-nav">
                <ul class="rules-nav-list">
                    <li ref="navItems" v-for="(item, key) in navItems" class="rules-nav-item animate-items"
                        :class="`item-${key+1}`">
                        <div class="nav-icon-wrapper">
                            <div class="nav-icon animate-img" :class="`icon-${key+1}`"
                                 :style="`background-image: url(static/img/rules/icons/${key + 1}.png)`"></div>
                        </div>
                        <div class="nav-text-wrapper">
                            <h5 class="text animate-text" v-html="item.text"></h5>
                            <div class="underline animate-line"></div>

                            <a href="#" class="nav-item-link animate-link" v-if="item.popup" @click.prevent="showVideoPopup(item.popup)">{{ item.linkText }}</a>
                            <span v-else @click="sendEvent(item)">
                               <router-link :to="item.link" class="nav-item-link animate-link"> {{ item.linkText }}</router-link>
                            </span>

                        </div>
                    </li>
                </ul>
                <a href="/static/rules/rules.pdf" target="_blank" class="rules-link">Полные правила</a>
            </div>
            <div ref="footballers" class="rules-footballers">
                <div class="title-wrapper">
                    <h2 ref="title" class="title">
                        Футболисты,<br>
                        с&nbsp;которыми смогут сразиться<br>
                        победители конкурса
                    </h2>
                </div>
                <ul class="rules-footballers-list">
                    <li ref="footballersItems" class="rules-footballers-item animate-items"
                        v-for="(item, key) in footballersItems"
                        :class="`item-${key+1}`">
                        <div class="footballer-img-wrapper">
                            <div class="footballer-img animate-img"
                                 :style="`background-image: url(static/img/rules/footballers/${item.img}.png)`"></div>
                            <!--:style="`background-image: url(static/img/rules/footballers/${key + 1}.png)`"></div>-->
                        </div>
                        <div class="footballer-text-wrapper">
                            <h5 class="footballer-text animate-text" v-html="item.text"></h5>
                            <div class="underline animate-line"></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>


<script>
    import {TimelineMax} from 'gsap'
    import Helpers from '@/tools/Helpers'

    const navItems = [
        {
            text: 'Пройди тест<br>на&nbsp;знание<br>истории<br>игры FIFA',
            link: '/test',
            linkText: 'Пройти'
        },
        {
            text: 'Зарегистрируйся<br>и&nbsp;сохрани<br>свой результат',
            link: '/',
            linkText: 'Создать',
            popup: 'Auth'
        },
        {
            text: 'Пришли<br>видеоповтор<br>гола',
            link: '/',
//            linkText: 'Прислать',
//            popup: 'Info'
        },
        {
            text: 'Следи<br>за&nbsp;результатами<br>других<br>участников',
            link: '/rating',
            linkText: 'Следить'
        },
        {
            text: 'Смотри<br>видео-отчеты<br>об играх<br>в&nbsp;редакции',
            link: '/video',
            linkText: 'Посмотреть'
        },
        {
            text: 'Тренируйся<br>в&nbsp;FIFA 18<br>и&nbsp;стань чемпионом!',
            link: '/product',
            linkText: 'Потренироваться'
        }
    ];

    const footballersItems = [
        {
            text: 'Георгий Джикия<br>16.11.2017',
            img: 'jk'
        },
        {
			text: 'Константин Кучаев<br>24.11.2017',
			img: 'kk'
        },
        {
			text: 'Дмитрий Сычев<br>27.11.2017',
			img: 'sch'
        },
        {
			text: 'Братья Миранчуки<br>28.11.2017',
			img: 'pr'
        },
        {
			text: 'Антон Шунин<br>05.12.2017',
			img: 'shn'
        }
    ];
    export default {
        name: 'Rules',
        data() {
            return {
            	Helpers,
                navItems,
                footballersItems,
                isFootballersAnimated: false,
                isTestAnimated: false
            }
        },

		computed: {
			currentWeek() {
				return this.$store.getters['getCurrentWeek'];
			},
			user() {
				return this.$store.getters['getUserData'];
			},
			isGuest() {
				return this.$store.getters['isGuest'];
			},
			userRating() {
				return this.$store.getters['getUserRatingList'];
			}
		},

        methods: {
			sendEvent(item) {
				Helpers.ga().send('click','page Rules', item.linkText)
			},
			showVideoPopup(name){
				if(name === 'Auth' && !this.isGuest){
                    this.$router.push('/profile')
                    return false;
				}
				this.$store.commit('SET_POPUP', {name: name});
			},
            isInViewport(el) {
                let rect = el.getBoundingClientRect();
                let html = document.documentElement;
                return rect.top <= (window.innerHeight || html.clientHeight) * .3;
            },
            animateNav() {
                let tl = new TimelineMax();
                let i = 0;
                let items = this.$refs.navItems;
                let overlay = this.$refs.overlay;

                tl
                    .staggerTo('.rules-nav-item', .3, {
                        opacity: 1, onComplete() {
                            items[i].classList.add('animate');
                            i++;
                        }
                    }, .4)
                    .to(overlay, 1, {opacity: 0, delay: .5})

            },
            animateFootballers() {
                let tl = new TimelineMax();
                let i = 0;
                let items = this.$refs.footballersItems;
                let title = this.$refs.title;

                tl
                    .to(title, .3, {y: 0})
                    .staggerTo('.rules-footballers-item', .3, {
                        opacity: 1, onComplete() {
                            items[i].classList.add('animate');
                            i++;
                        }
                    }, .4)

            },
            animateTest() {

                let tl = new TimelineMax();
                let circleWrapper = this.$refs.circleWrapper;
                let testContent = this.$refs.testContent;
                tl
                    .to(circleWrapper, 1, {height: '43.125em', delay: .5})
                    .to(testContent, 1, {height: '25em'}, '-=1');

            }

        },
        mounted() {
            this.animateNav();
            this.animateFootballers();

			this.Helpers.ga().send('load', 'Страница правил');

        },
        components: {
			Helpers
        }

    }
</script>



// WEBPACK FOOTER //
// Rules.vue?738cb333